import styled from 'styled-components';

type RadioItemProps = {
  title: string;
  isSelected?: boolean;
  fullWidth?: boolean;
  onClick?: () => void;
  selectedNumber?: number;
};

export default function RadioItem({
  title,
  isSelected = false,
  fullWidth = false,
  selectedNumber,
  onClick
}: RadioItemProps) {
  return (
    <Wrapper isSelected={isSelected} fullWidth={fullWidth} onClick={onClick}>
      <Title isSelected={isSelected}>{title}</Title>
      {selectedNumber && <SelectedNumber>{selectedNumber}</SelectedNumber>}
    </Wrapper>
  );
}

const Wrapper = styled.div<{ isSelected: boolean; fullWidth: boolean }>`
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  padding: 16.5px 16px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.gray800};
  border: ${({ isSelected, theme }) =>
    isSelected
      ? `2px solid ${theme.palette.brand400}`
      : `2px solid ${theme.palette.gray600}`};
  color: ${({ theme }) => theme.palette.gray25};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled.span<{ isSelected: boolean }>`
  font-size: 16px;
  ${({ isSelected, theme }) =>
    isSelected
      ? `color: ${theme.palette.gray15}; font-weight: 600;`
      : `font-weight: 400; color: ${theme.palette.gray25};`}
`;

const CheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 10L4 12L10 18L20 8L18 6L10 14L6 10Z"
      fill="#7750E9"
    />
  </svg>
);

const SelectedNumber = styled.div`
  width: 20px;
  height: 20px;
  gap: 0px;
  opacity: 0px;
  background-color: #7750e9;
  border-radius: 50%;

  font-family: Pretendard Variable;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
`;
